import { css, keyframes } from '@emotion/css';
import { colors } from 'constants/theme';
import titleBg from 'assets/images/bg/titleBg.png';
import bgsport from 'assets/images/bg/bg-sport.png';

const glass = keyframes`
  0%{
    background-position:120%;
    opacity: 1;
  }
  100%{
    background-position:-160%;
    opacity: 0;
  }
`;
const homePageStyles = {
    homeContainer: css`
        background: ${colors.white};
    `,
    bannerBg: css`
        width: 100%;
        img {
            width: 100%;
        }
        /* height: 310px; // hoặc chiều cao mong muốn (có thể dùng responsive bằng vh/vw)
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat; */
    `,
    marquee: css`
        background: #000;
        margin-top: -5px;
    `,
    megaphone: css`
        width: 20px;
        margin-left: 12px;
    `,
    timeNow: css`
        display: flex;
        align-items: center;
        flex: 0 0 156px;
    `,
    slideText: css`
        flex: 1;
        max-width: calc(100% - 156px);
        position: relative;
        height: 40px;

        &::before,
        &::after {
            content: '';
            position: absolute;
            top: 0;
            width: 120px;
            height: 100%;
            z-index: 2;
            pointer-events: none;
        }
        &::before {
            background: linear-gradient(90deg, rgba(18, 24, 35, 1) 0%, rgba(26, 32, 44, 0) 100%);
            left: 0;
        }
        &::after {
            right: 0;
            background: linear-gradient(270deg, rgba(18, 24, 35, 1) 0%, rgba(26, 32, 44, 0) 100%);
        }
    `,
    bannerSlide: css`
        /* min-height: 370px; */
        .swiper-pagination {
            bottom: 20px !important;
            .swiper-pagination-bullet {
                background: #f5f5f5;
                transition: 0.25s;
                opacity: 1;
                width: 50px;
                height: 8px;
                border-radius: 1px;
                transform: skew(25deg);
            }
            .swiper-pagination-bullet-active {
                background: ${colors.orange};
            }
        }
    `,
    imgBanner: css`
        width: 100%;
    `,
    section: css`
        padding: 1px 0 20px;
    `,
    gameWrap: css`
        display: flex;
        gap: 15px;
    `,
    gameRight: css`
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    `,
    liveSection: css`
        background-size: cover;
        transform: translateY(-3px);
        margin-bottom: -3px;
    `,
    title: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        margin-top: 30px;
        .title-game {
            background: url(${titleBg}) no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            padding: 10px 200px;
            h6 {
                font-size: 22px;
                font-weight: 600;
                color: #fff;
            }
        }
    `,
    titleIcon: css`
        width: 40px;
        margin-right: 10px;
    `,
    btnViewAll: css`
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border: 1px solid ${colors.blue};
        border-radius: 4px;
        cursor: pointer;
        &:hover {
            img {
                transform: translateX(3px);
            }
        }
        span {
            color: ${colors.gray};
            font-size: 12px;
            font-weight: bold;
        }
        img {
            width: 16px;
            margin-left: 8px;
            transition: 0.25s;
        }
    `,
    gameItem: css`
        position: relative;
        height: fit-content;
        transition: border-radius 650ms ease-in-out;
        overflow: hidden;
        cursor: pointer;
        width: 25% !important;
        img {
            border-radius: 10px;
        }
        &:hover {
            transition: all 0.15s ease-out;
            img {
                transition: all 0.15s ease-out;
                transform: scale(1.03);
            }
            button {
                img {
                    transition: all 0.15s ease-out;
                    transform: scale(1.1);
                }
            }
        }
        &.comingsoon {
            filter: grayscale(1);
            pointer-events: none;
        }
    `,
    itemRight: css`
        width: 19%;
        .imgitem {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    `,
    itemLeft: css`
        width: 20%;
        border-radius: 10px;
        .imggame {
            width: 100%;
            border-radius: 10px;
        }
    `,

    btnPlayGame: css`
        position: absolute;
        left: -50px;
        bottom: 25px;
        button {
            cursor: pointer;
        }
        img {
            width: 40%;
        }
    `,
    // football section
    football: css`
        background: url(${bgsport}) center center no-repeat;
        background-size: 100% 100%;
    `,
    footballWrap: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin-top: 30px;
    `,
    lottery: css`
        background-size: cover;
        padding: 20px 10px;
    `,
    intro: css`
        color: #4e5461;
    `,
    introTitle: css`
        font-size: 18px;
        text-align: center;
        margin-bottom: 18px;
    `,
    introDesc: css`
        font-size: 14px;
    `,
};
export default homePageStyles;
